import { createSlice } from '@reduxjs/toolkit'
import { getTaxonomyVendorSkuIdOptionsAsync } from 'src/services/dataManagement/dataManagement.services'

const initialState = {
  loading: false,
  options: {
    vendorIdData: [],
    skuPrimaryIdData: [],
    l1Data: [],
    l2Data: [],
    l3Data: [],
  },
}

export const getTaxonomyIdsOptionsSlice = createSlice({
  name: 'filter-options',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaxonomyVendorSkuIdOptionsAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(getTaxonomyVendorSkuIdOptionsAsync.fulfilled, (state, action) => {
        const { l1, l2, l3, vendorId, skuPrimaryId } = action.payload?.data || {}

        state.options.l1Data = l1 || []
        state.options.l2Data = l2 || []
        state.options.l3Data = l3 || []
        state.options.vendorIdData = vendorId || []
        state.options.skuPrimaryIdData = skuPrimaryId || []

        state.loading = false
      })
      .addCase(getTaxonomyVendorSkuIdOptionsAsync.rejected, (state) => {
        state.loading = false
        state.options = initialState.options
      })
  },
})

export default getTaxonomyIdsOptionsSlice.reducer
